module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_9006.60817fe8.png";